import { ConfigContext } from './types';

export const envNameSet = async (
  ctx: ConfigContext,
  name: string,
): Promise<void> => {
  ctx.commit('envNameSet', name);
};
